





































import { Component, Vue } from 'vue-property-decorator'
import { isXcxWeb } from '@ivy/fts/utils'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component({
  components: {
    CustomerButton: () => import('@ivy/fts/comps/Customer'),
  },
})
export default class MyLogistics extends Vue {
  isXcxWeb = isXcxWeb()
  list: any[] = []
  statusMap = {
    [-1]: '待发货',
    0: '已发货',
    1: '运输中',
    2: '正在派件',
    3: '已签收',
    4: '派送失败',
    5: '疑难件',
    6: '退件签收',
  }
  iconMap = {
    [-1]: 'wait',
    0: 'shipped',
    1: 'transit',
    2: 'sending',
    3: 'already',
    4: 'sending-rror',
    5: 'problem',
    6: 'return',
  }
  jumpMap = {
    1: 'orderTracking',
    2: 'logisticsInfo',
    3: 'logisticsList',
    4: 'orderLogistics',
  }
  get iconSrc() {
    return s => {
      return this.iconMap[s]
        ? require(`@/assets/order/${this.iconMap[s]}.png`)
        : ''
    }
  }
  async created() {
    this.$title('查看物流')
    await env.init()
    let isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }
    let tid = this.$route.query.tid || 'D20210910170100049985'
    let conf = {
      disableAlert: true,
    }
    let { data = [] } = await this.$axios.get(
      '/api/goods/shop/search/order/getOrderSkuExpress',
      {
        params: {
          tid,
        },
        ...conf,
      }
    )
    this.list = data
  }
  goDetail(item) {
    if (!item.express_num) {
      return this.$Toast('暂无物流信息')
    }
    this.$router.push({
      path: this.jumpMap[item.jump_type],
      query: {
        expressNum: item.exp_number || item.express_num || '',
        tid: this.$route.query.tid,
        barcode: item.bar_code || '',
      },
    })
  }
}
